(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("@alifd/next"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "@alifd/next", "moment"], factory);
	else if(typeof exports === 'object')
		exports["BizComps"] = factory(require("react"), require("react-dom"), require("@alifd/next"), require("moment"));
	else
		root["BizComps"] = factory(root["React"], root["ReactDOM"], root["Next"], root["moment"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__40__, __WEBPACK_EXTERNAL_MODULE__43__, __WEBPACK_EXTERNAL_MODULE__87__) {
return 